import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Staff() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [newStaff, setNewStaff] = useState({
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    role: 'staff',
    commission_rate: 0,
    base_salary: 0,
    color_code: '#6366f1',
    password: '',
    is_active: 1,
    show_in_calendar: true
  });

  useEffect(() => {
    fetchStaff();
  }, []);

  const fetchStaff = async () => {
    try {
      const token = localStorage.getItem('crm_token');
      const response = await axios.get('/api/staff', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStaff(response.data);
    } catch (error) {
      console.error('Fetch staff error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenAddModal = () => {
    setIsEditMode(false);
    setNewStaff({
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      role: 'staff',
      commission_rate: 0,
      base_salary: 0,
      color_code: '#6366f1',
      password: '',
      is_active: 1,
      show_in_calendar: true
    });
    setShowModal(true);
  };

  const handleOpenEditModal = (member, e) => {
    if (e) e.stopPropagation();
    setIsEditMode(true);
    setSelectedStaff(member);
    setNewStaff({
      first_name: member.first_name || '',
      last_name: member.last_name || '',
      phone: member.phone || '',
      email: member.email || '',
      role: member.role || 'staff',
      commission_rate: member.commission_rate || 0,
      base_salary: member.base_salary || 0,
      color_code: member.color_code || '#6366f1',
      password: '', // Leave blank for security
      is_active: member.is_active !== undefined ? member.is_active : 1,
      show_in_calendar: member.show_in_calendar === undefined ? true : !!member.show_in_calendar
    });
    setShowModal(true);
    setShowDetailModal(false);
  };

  const handleDeleteStaff = async (id, e) => {
    if (e) e.stopPropagation();
    if (!window.confirm('Bu personeli pasifleştirmek istediğinize emin misiniz?')) return;
    try {
      const token = localStorage.getItem('crm_token');
      await axios.delete(`/api/staff/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchStaff();
      setShowDetailModal(false);
    } catch (error) {
      alert('Personel silinemedi veya pasifleştirilemedi.');
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('crm_token');
      if (isEditMode && selectedStaff) {
        await axios.put(`/api/staff/${selectedStaff.id}`, newStaff, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post('/api/staff', newStaff, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      setShowModal(false);
      fetchStaff();
    } catch (error) {
      alert(isEditMode ? 'Personel güncellenemedi' : 'Personel eklenemedi');
    }
  };

  const handleViewDetail = async (staffMember) => {
    try {
      const token = localStorage.getItem('crm_token');
      const response = await axios.get(`/api/staff/${staffMember.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSelectedStaff(response.data);
      setShowDetailModal(true);
    } catch (error) {
      console.error('Fetch staff detail error:', error);
    }
  };

  const roleLabels = {
    owner: 'Sahip',
    manager: 'Yönetici',
    senior_staff: 'Kıdemli Personel',
    staff: 'Personel',
    therapist: 'Terapist / Uzman',
    intern: 'Stajyer'
  };

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem' }}>Yükleniyor...</div>;

  return (
    <div style={{ padding: '1rem' }}>
      <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <h1 className="page-title" style={{ margin: 0 }}>Personel Yönetimi</h1>
        <button className="btn btn-primary" onClick={handleOpenAddModal}>
          + Yeni Personel
        </button>
      </div>

      <div className="grid-3" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '1.5rem' }}>
        {staff.map(member => (
          <div key={member.id} className="card staff-card" style={{ position: 'relative', cursor: 'pointer', transition: 'all 0.3s ease', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '16px', background: 'rgba(13, 18, 30, 0.45)', padding: '1.5rem' }} onClick={() => handleViewDetail(member)}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.25rem' }}>
              <div style={{
                width: 54,
                height: 54,
                borderRadius: '50%',
                background: member.color_code || '#6366f1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontWeight: 700,
                fontSize: '1.25rem',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
              }}>
                {(member.first_name || 'P')[0].toUpperCase()}{(member.last_name || '')[0]?.toUpperCase() || ''}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: '1.1rem', color: '#ffffff' }}>{member.first_name} {member.last_name}</div>
                <div className="text-muted" style={{ fontSize: '0.85rem', color: '#9ca3af', marginTop: '2px' }}>{roleLabels[member.role] || member.role}</div>
              </div>
              
              <div className="actions" style={{ display: 'flex', gap: '0.5rem' }}>
                <button 
                  className="btn btn-sm" 
                  style={{ background: 'rgba(255,255,255,0.05)', border: 'none', borderRadius: '8px', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--tertiary)', cursor: 'pointer' }}
                  onClick={(e) => handleOpenEditModal(member, e)}
                  title="Düzenle"
                >
                  ✏️
                </button>
                <button 
                  className="btn btn-sm" 
                  style={{ background: 'rgba(255,255,255,0.05)', border: 'none', borderRadius: '8px', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ef4444', cursor: 'pointer' }}
                  onClick={(e) => handleDeleteStaff(member.id, e)}
                  title="Sil"
                >
                  🗑️
                </button>
              </div>
            </div>
            
            <div style={{ fontSize: '0.875rem', color: '#d1d5db', borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <div>📞 <span style={{ marginLeft: '0.5rem' }}>{member.phone || '-'}</span></div>
              <div>✉️ <span style={{ marginLeft: '0.5rem' }}>{member.email || '-'}</span></div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '0.25rem' }}>
                <span>💰 Komisyon: <strong>%{member.commission_rate || '0'}</strong></span>
                <span className={`badge ${member.is_active ? 'badge-confirmed' : 'badge-cancelled'}`} style={{ background: member.is_active ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)', color: member.is_active ? '#10b981' : '#ef4444', padding: '0.25rem 0.5rem', borderRadius: '6px', fontSize: '0.75rem' }}>
                  {member.is_active ? 'Aktif' : 'Pasif'}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal-overlay" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setShowModal(false)}>
          <div className="modal" style={{ background: '#0d121e', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '20px', padding: '2rem', width: '90%', maxWidth: '560px', color: 'white', position: 'relative' }} onClick={e => e.stopPropagation()}>
            <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
              <h3 className="modal-title" style={{ margin: 0, fontSize: '1.25rem' }}>{isEditMode ? 'Personel Düzenle' : 'Yeni Personel Ekle'}</h3>
              <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.75rem', cursor: 'pointer', color: '#9ca3af' }}>×</button>
            </div>

            <form onSubmit={handleFormSubmit}>
              <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label className="form-label">Ad *</label>
                  <input
                    type="text"
                    className="input"
                    value={newStaff.first_name}
                    onChange={e => setNewStaff({ ...newStaff, first_name: e.target.value })}
                    required
                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '0.6rem 0.8rem', color: 'white' }}
                  />
                </div>
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label className="form-label">Soyad *</label>
                  <input
                    type="text"
                    className="input"
                    value={newStaff.last_name}
                    onChange={e => setNewStaff({ ...newStaff, last_name: e.target.value })}
                    required
                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '0.6rem 0.8rem', color: 'white' }}
                  />
                </div>
              </div>
              
              <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label className="form-label">Telefon</label>
                  <input
                    type="tel"
                    className="input"
                    value={newStaff.phone}
                    onChange={e => setNewStaff({ ...newStaff, phone: e.target.value })}
                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '0.6rem 0.8rem', color: 'white' }}
                  />
                </div>
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label className="form-label">E-posta</label>
                  <input
                    type="email"
                    className="input"
                    value={newStaff.email}
                    onChange={e => setNewStaff({ ...newStaff, email: e.target.value })}
                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '0.6rem 0.8rem', color: 'white' }}
                  />
                </div>
              </div>

              <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label className="form-label">Rol</label>
                  <select
                    className="input"
                    value={newStaff.role}
                    onChange={e => setNewStaff({ ...newStaff, role: e.target.value })}
                    style={{ background: '#111827', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '0.6rem 0.8rem', color: 'white' }}
                  >
                    <option value="staff">Personel</option>
                    <option value="therapist">Terapist / Uzman</option>
                    <option value="senior_staff">Kıdemli Personel</option>
                    <option value="manager">Yönetici</option>
                    <option value="owner">Sahip</option>
                    <option value="intern">Stajyer</option>
                  </select>
                </div>
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label className="form-label">Komisyon (%)</label>
                  <input
                    type="number"
                    className="input"
                    value={newStaff.commission_rate}
                    onChange={e => setNewStaff({ ...newStaff, commission_rate: e.target.value })}
                    step="0.01"
                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '0.6rem 0.8rem', color: 'white' }}
                  />
                </div>
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label className="form-label">Sabit Maaş (₺)</label>
                  <input
                    type="number"
                    className="input"
                    value={newStaff.base_salary}
                    onChange={e => setNewStaff({ ...newStaff, base_salary: e.target.value })}
                    step="0.01"
                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '0.6rem 0.8rem', color: 'white' }}
                  />
                </div>
              </div>

              <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '3fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label className="form-label">{isEditMode ? 'Şifre (Değiştirmek istemiyorsanız boş bırakın)' : 'Şifre *'}</label>
                  <input
                    type="password"
                    className="input"
                    value={newStaff.password}
                    onChange={e => setNewStaff({ ...newStaff, password: e.target.value })}
                    placeholder="******"
                    required={!isEditMode}
                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '0.6rem 0.8rem', color: 'white' }}
                  />
                </div>
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label className="form-label">Renk</label>
                  <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                    <input
                      type="color"
                      value={newStaff.color_code}
                      onChange={e => setNewStaff({ ...newStaff, color_code: e.target.value })}
                      style={{ border: 'none', padding: 0, width: '40px', height: '40px', background: 'none', cursor: 'pointer', borderRadius: '8px' }}
                    />
                    <span style={{ fontSize: '0.8rem', fontFamily: 'monospace' }}>{newStaff.color_code}</span>
                  </div>
                </div>
              </div>

              {isEditMode && (
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
                  <input
                    type="checkbox"
                    id="isActiveCheck"
                    checked={newStaff.is_active === 1}
                    onChange={e => setNewStaff({ ...newStaff, is_active: e.target.checked ? 1 : 0 })}
                    style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                  />
                  <label htmlFor="isActiveCheck" style={{ cursor: 'pointer' }}>Bu Personel Aktif mi?</label>
                </div>
              )}

              <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1.5rem' }}>
                <input
                  type="checkbox"
                  id="showInCalendarCheck"
                  checked={newStaff.show_in_calendar}
                  onChange={e => setNewStaff({ ...newStaff, show_in_calendar: e.target.checked })}
                  style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                />
                <label htmlFor="showInCalendarCheck" style={{ cursor: 'pointer' }}>Randevular takviminde sütun olarak görünsün</label>
              </div>

              <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '0.8rem', fontSize: '1rem', borderRadius: '10px' }}>
                {isEditMode ? 'Değişiklikleri Kaydet' : 'Personel Ekle'}
              </button>
            </form>
          </div>
        </div>
      )}

      {showDetailModal && selectedStaff && (
        <div className="modal-overlay" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setShowDetailModal(false)}>
          <div className="modal" style={{ background: '#0d121e', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '20px', padding: '2rem', width: '90%', maxWidth: '560px', color: 'white', position: 'relative' }} onClick={e => e.stopPropagation()}>
            <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '1rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div style={{ width: 44, height: 44, borderRadius: '50%', background: selectedStaff.color_code || 'var(--tertiary)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
                  {(selectedStaff.first_name || '')[0]?.toUpperCase()}{(selectedStaff.last_name || '')[0]?.toUpperCase()}
                </div>
                <div>
                  <h3 className="modal-title" style={{ margin: 0, fontSize: '1.25rem' }}>{selectedStaff.first_name} {selectedStaff.last_name}</h3>
                  <div style={{ fontSize: '0.85rem', color: '#9ca3af', marginTop: '2px' }}>{roleLabels[selectedStaff.role] || selectedStaff.role}</div>
                </div>
              </div>
              <button onClick={() => setShowDetailModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.75rem', cursor: 'pointer', color: '#9ca3af' }}>×</button>
            </div>

            <div style={{ fontSize: '0.9rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div>
                  <span style={{ color: '#9ca3af', fontSize: '0.8rem', display: 'block' }}>Telefon</span>
                  <strong>{selectedStaff.phone || '-'}</strong>
                </div>
                <div>
                  <span style={{ color: '#9ca3af', fontSize: '0.8rem', display: 'block' }}>E-posta</span>
                  <strong>{selectedStaff.email || '-'}</strong>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div>
                  <span style={{ color: '#9ca3af', fontSize: '0.8rem', display: 'block' }}>Komisyon Oranı</span>
                  <strong>%{selectedStaff.commission_rate || '0'}</strong>
                </div>
                <div>
                  <span style={{ color: '#9ca3af', fontSize: '0.8rem', display: 'block' }}>Durum</span>
                  <span className={`badge ${selectedStaff.is_active ? 'badge-confirmed' : 'badge-cancelled'}`} style={{ display: 'inline-block', marginTop: '2px', background: selectedStaff.is_active ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)', color: selectedStaff.is_active ? '#10b981' : '#ef4444', padding: '0.2rem 0.5rem', borderRadius: '6px', fontSize: '0.75rem' }}>
                    {selectedStaff.is_active ? 'Aktif' : 'Pasif'}
                  </span>
                </div>
              </div>
              
              {selectedStaff.working_hours?.length > 0 && (
                <div style={{ marginTop: '0.5rem', borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '1rem' }}>
                  <strong style={{ display: 'block', marginBottom: '0.5rem', color: '#f3f4f6' }}>Çalışma Saatleri</strong>
                  <table className="table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.05)', textAlign: 'left' }}>
                        <th style={{ padding: '0.5rem 0', color: '#9ca3af', fontWeight: 'normal', fontSize: '0.8rem' }}>Gün</th>
                        <th style={{ padding: '0.5rem 0', color: '#9ca3af', fontWeight: 'normal', fontSize: '0.8rem' }}>Başlangıç</th>
                        <th style={{ padding: '0.5rem 0', color: '#9ca3af', fontWeight: 'normal', fontSize: '0.8rem' }}>Bitiş</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedStaff.working_hours.map(wh => (
                        <tr key={wh.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.02)' }}>
                          <td style={{ padding: '0.5rem 0' }}>{['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'][wh.day_of_week]}</td>
                          <td style={{ padding: '0.5rem 0' }}>{wh.start_time?.slice(0, 5)}</td>
                          <td style={{ padding: '0.5rem 0' }}>{wh.end_time?.slice(0, 5)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {selectedStaff.services?.length > 0 && (
                <div style={{ marginTop: '0.5rem', borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '1rem' }}>
                  <strong style={{ display: 'block', marginBottom: '0.5rem', color: '#f3f4f6' }}>Verdiği Hizmetler</strong>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                    {selectedStaff.services.map(s => (
                      <span key={s.id} className="badge badge-confirmed" style={{ background: 'rgba(var(--tertiary-rgb), 0.15)', color: '#a5b4fc', padding: '0.25rem 0.6rem', borderRadius: '8px', fontSize: '0.8rem' }}>{s.name}</span>
                    ))}
                  </div>
                </div>
              )}

              <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '1.5rem' }}>
                <button 
                  className="btn btn-primary" 
                  style={{ flex: 1, padding: '0.6rem', borderRadius: '8px' }}
                  onClick={(e) => handleOpenEditModal(selectedStaff, e)}
                >
                  ✏️ Düzenle
                </button>
                <button 
                  className="btn btn-secondary" 
                  style={{ flex: 1, padding: '0.6rem', borderRadius: '8px', background: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', border: '1px solid rgba(239, 68, 68, 0.2)' }}
                  onClick={(e) => handleDeleteStaff(selectedStaff.id, e)}
                >
                  🗑️ Pasifleştir
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Staff;
